module.exports = __webpack_public_path__ + "img/pr-1.a9b94b54.png";